const professionList =
 [
   "IT Professional",
   "MFD",
   "Banker",
   "Insurance",
   "CFP / CWM / PFP / RIA / CFA",
   "Stock Broker",
   "CA/Tax Consultant",
   "Loan Advisor",
   "Others"
 ];
export default professionList;

